import * as Sentry from '@sentry/react';
import { apiVersion, baseUrl } from './ShoppingApi';
import { Luci_Shopping_Api_Requests_CapturePayPalOrderRequest } from '../types/api/v7.1/models/Luci_Shopping_Api_Requests_CapturePayPalOrderRequest';
import { Luci_Shopping_Api_Responses_ShoppingCaptureOrderResponse } from '../types/api/v7.1/models/Luci_Shopping_Api_Responses_ShoppingCaptureOrderResponse';

/**
 * Post payment
 * @param request
 */
async function postWebCheckoutCapturePayPal(
  request: Luci_Shopping_Api_Requests_CapturePayPalOrderRequest
): Promise<Luci_Shopping_Api_Responses_ShoppingCaptureOrderResponse> {
  const url = `${baseUrl}/${apiVersion}/invoices/capture-paypal-order`;
  const errorDisplayMessage = 'Unable to process transaction.';
  try {
    const response = await fetch(url, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });
    const responseBody =
      (await response.json()) as Luci_Shopping_Api_Responses_ShoppingCaptureOrderResponse;

    if (!response.ok) {
      const level = response.status >= 500 ? 'error' : 'warning';

      Sentry.withScope((scope) => {
        scope.setLevel(level);
        Sentry.captureMessage(
          `${level} - ${response.status}: webcheckout PayPal - ${response.statusText}`
        );
      });

      throw new Error(
        `Response status: ${response.status} ${response.statusText}`
      );
    }

    return responseBody;
  } catch (e) {
    throw new Error(`Network error: ${errorDisplayMessage}`);
  }
}

export default postWebCheckoutCapturePayPal;
